/**
 * Client Management Page
 * Access: Coach, Admin
 *
 * Allows coaches to:
 * - View assigned clients
 * - Track client progress
 * - Schedule sessions
 * - Review assessments
 */

export function ClientsPage() {
  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-text-dark">My Clients</h1>

        <div className="grid gap-6 md:grid-cols-4 mb-8">
          <div className="card text-center">
            <div className="text-4xl font-bold mb-2 text-primary">0</div>
            <div className="text-text-secondary">Active Clients</div>
          </div>
          <div className="card text-center">
            <div className="text-4xl font-bold mb-2 text-secondary">0</div>
            <div className="text-text-secondary">Sessions This Week</div>
          </div>
          <div className="card text-center">
            <div className="text-4xl font-bold mb-2 text-accent-orange">0</div>
            <div className="text-text-secondary">Pending Reviews</div>
          </div>
          <div className="card text-center">
            <div className="text-4xl font-bold mb-2 text-primary-dark">0</div>
            <div className="text-text-secondary">Unread Messages</div>
          </div>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <div className="card">
            <h2 className="text-xl font-semibold mb-4 text-text-dark">
              Client List
            </h2>
            <div className="text-center py-12 text-text-secondary">
              <p>No clients assigned yet.</p>
            </div>
          </div>

          <div className="card">
            <h2 className="text-xl font-semibold mb-4 text-text-dark">
              Upcoming Sessions
            </h2>
            <div className="text-center py-12 text-text-secondary">
              <p>No upcoming sessions scheduled.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
